document.addEventListener("DOMContentLoaded", function() {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
    trackVisibility: true,
    delay: 100
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      const lazyObj = entry.target;
      if (lazyObj.nodeName === 'IMG' || lazyObj.nodeName === 'IFRAME') {
        if (entry.isIntersecting && entry.isVisible) {
            let lazy = !lazyObj.src ?? true;

            if(lazy) {
              lazyObj.src = lazyObj.dataset.src;
            }

            lazyObj.classList.remove("lazy");
            observer.unobserve(lazyObj)
        }
      }
      else if (lazyObj.nodeName === 'VIDEO'){
        if (entry.isIntersecting) {
          for (let source in lazyObj.children) {
            let videoSource = lazyObj.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          lazyObj.load();
          lazyObj.classList.remove("lazy");
          observer.unobserve(lazyObj)
        }

      }

    })
  }, options)


  const arr = document.querySelectorAll("img.Image--lazyLoad, video.Image--lazyLoad");
  arr.forEach(i => {
    observer.observe(i)
  })

  let lazyloadThrottleTimeout;

  function lazyload() {
    let lazyloadImages = document.querySelectorAll("iframe.Image--lazyLoad");
    if(lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function() {
      let scrollTop = window.pageYOffset;
      lazyloadImages.forEach(function(img) {
        let lazy = !img.src ?? true;;

        if(lazy && img.offsetTop < (window.innerHeight + scrollTop)) {
          img.src = img.dataset.src;
          img.classList.remove('lazy');
        }

      });
      if(lazyloadImages.length == 0) {
        document.removeEventListener("scroll", lazyload);
        window.removeEventListener("resize", lazyload);
        window.removeEventListener("orientationChange", lazyload);
      }
    }, 20);
  }
  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);

});
